import React from 'react';

const PromotionCouponRedemptionFormModal = React.lazy(() => import('../components/FormModal'));
const promotionCouponRedemptionModalRegistry = {
    core_promotionCouponRedemptionId: PromotionCouponRedemptionFormModal
};
export default promotionCouponRedemptionModalRegistry;
